<template>
  <div>
    <div>
      <div v-if="company">
        <div class="mt--2">
          <b-card no-body>
            <template #header>
              {{ company.companyName }}
            </template>
            <b-tabs card v-model="tabIndex">
              <b-tab title="Settings" lazy>
                <div class="pt-5">
                  <settings
                    :company="company"
                    :bindReceiptSettings="bindReceiptSettings"
                    @updateReceiptSettings="updateReceiptSettings"
                    :bindMembershipSettings="bindMembershipSettings"
                    @updateMembershipSettings="updateMembershipSettings"
                    :bindPaymentPlanSettings="bindPaymentPlanSettings"
                    @updatePaymentPlanSettings="updatePaymentPlanSettings"
                    :bindApptSettings="bindApptSettings"
                    @updateApptSettings="updateApptSettings"
                    :bindPaymentPageSettings="bindPaymentPageSettings"
                    :updatePaymentPageSettings="updatePaymentPageSettings"
                    :sendPaymentPageEmail="sendPaymentPageEmail"
                  ></settings>
                </div>
              </b-tab>

              <b-tab title="User Admin" lazy>
                <b-card-text class="p-5">
                  <manage-users
                    :bindUsers="bindUsers"
                    :userUpdated="userUpdated"
                    :bindRoles="bindRoles"
                  ></manage-users>
                </b-card-text>
              </b-tab>

              <b-tab title="Contact Information" lazy>
                <div class="col-sm-12 col-lg-6 col-xl-6 p-5">
                  <div class="card shadow-sm border card-body contact-body">
                    <validation-observer
                      ref="formValidator"
                      v-slot="{ handleSubmit }"
                    >
                      <b-form
                        role="form"
                        @submit.prevent="handleSubmit(submitCompany)"
                      >
                        <base-input
                          label="Practice Name"
                          v-model="company.companyName"
                          rules="required"
                          name="Company Name"
                        ></base-input>

                        <base-input
                          label="Address"
                          v-model="company.address1"
                        ></base-input>

                        <base-input v-model="company.address2"></base-input>

                        <b-row>
                          <b-col>
                            <base-input
                              label="City"
                              v-model="company.city"
                            ></base-input>
                          </b-col>
                          <b-col>
                            <base-input
                              v-model="company.state"
                              label="State"
                            ></base-input>
                          </b-col>
                          <b-col>
                            <base-input
                              v-model="company.zipCode"
                              label="Zip Code"
                            ></base-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <base-input
                              v-model="company.email"
                              label="Email"
                              rules="required|email"
                              name="email"
                            ></base-input>
                          </b-col>
                          <b-col>
                            <base-input-phone
                              v-model="company.phoneNumber"
                              label="Phone Number"
                              rules="phoneNumber"
                              name="Phone Number"
                            ></base-input-phone>
                          </b-col>
                        </b-row>

                        <div class="form-control-label">
                          Time Zone
                        </div>
                        <b-form-select
                          label="Time Zone"
                          v-model="company.timeZoneIndex"
                          :options="company.timeZones"
                          class="form-control mt-2"
                        ></b-form-select>

                        <b-button
                          type="submit"
                          class="btn btn-block mt-5"
                          variant="primary"
                          >Submit</b-button
                        >
                      </b-form>
                    </validation-observer>
                  </div>
                </div>
              </b-tab>
              <!--
              <b-tab title="Branding" lazy>
                <div class="p-5">
                  <h2>Logo</h2>
                  Set a logo that will be used on customer facing websites, and
                  invoices.
                  <br /><br />
                  <UploadImage
                    :imageUrl="company.companyImageUrl"
                    @url="imageUrlUpdated"
                  />
                  <hr />
                  <h2>Link/Button Colors</h2>
                  Set the colors you would like your buttons, and links that are
                  presented to your customers.
                  <br /><br />
                  <input type="color" v-model="company.linkHexColorConverted" />
                  <b-button
                    size="sm"
                    variant="primary"
                    class="ml-3 mt--1"
                    @click="updateHexColor"
                    >Save</b-button
                  >
                </div>
              </b-tab>
              -->
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Settings from "@/views/Components/Company/Settings";
import ManageUsers from "@/views/Components/User/ManageUsers";
import UploadImage from "@/views/Components/UploadImage";

export default {
  title: "Your Company",
  components: {
    "manage-users": ManageUsers,
    UploadImage,
    Settings,
  },
  inject: ["companyService", "hasRole"],
  data() {
    return {
      companyId: null,
      company: null,
      timeZones: [],
    };
  },
  async mounted() {
    let r = await this.$client.get("/api/company/getActiveCompany");
    r.data.value.linkHexColorConverted = "#" + r.data.value.linkHexColor;

    this.company = r.data.value;
  },
  methods: {
    async bindMembershipSettings() {
      let r = await this.$client.get(
        "/api/company/getMembershipSettingsActiveCompany"
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindRoles() {
      let r = await this.$client.get("/api/user/getSystemRolesActiveCompany");
      if (r.data.isSuccess) return r.data.value.roles;
    },
    async bindReceiptSettings() {
      let r = await this.$client.get(
        "/api/company/getReceiptSettingsActiveCompany"
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async updateHexColor() {
      let r = await this.$client.post("/api/company/updateHexColor", {
        linkHexColor: this.company.linkHexColorConverted,
      });
      if (r.data.isSuccess)
        this.$emitter.emit("success", { message: "Hex Color Saved" });
    },
    async bindPaymentPageSettings() {
      let r = await this.$client.get(
        "/api/company/getPaymentPageSettingsActiveCompany"
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async imageUrlUpdated(url) {
      if (!url) return;

      let r = await this.$client.post("/api/company/updateCompanyImageUrl", {
        companyImageUrl: url,
      });
      if (r.data.isSuccess)
        this.$emitter.emit("success", { message: "Company Image Saved" });
    },
    async bindApptSettings() {
      let r = await this.$client.get(
        "/api/company/getApptSettingsActiveCompany"
      );
      if (r.data.isSuccess) return r.data.value;
    },
    async bindPaymentPlanSettings() {
      let r = await this.$client.get(
        "/api/company/getPaymentPlanSettingsActiveCompany"
      );
      if (r.data.isSuccess) return r.data.value;
    },

    async userUpdated(user) {
      var self = this;

      user.companyId = this.companyId;

      let response = await this.$client.post(
        "/api/user/upsertActiveCompanyUser",
        user
      );

      if (response.data.isSuccess) {
        if (!user.id)
          self.$emitter.emit("success", {
            title: "Added",
            message: "The user has been added.",
          });
        else
          self.$emitter.emit("success", {
            title: "Updated",
            message: "User has been updated.",
          });
      }
    },
    async updatePaymentPlanSettings(paymentPlanSettings) {
      let r = await this.$client.post(
        "/api/company/updatePaymentPlanSettingsActiveCompany",
        paymentPlanSettings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Payment Plan Settings Updated",
        });
      }
    },
    async updateApptSettings(a) {
      let r = await this.$client.post(
        "/api/company/updateApptSettingsActiveCompany",
        a
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Appointment Settings Updated",
        });
      }
    },
    async updateMembershipSettings(membershipSettings) {
      let r = await this.$client.post(
        "/api/company/updateMembershipSettingsActiveCompany",
        membershipSettings
      );
      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Membership Settings Updated",
        });
      }
    },
    async updatePaymentPageSettings(pp) {
      let r = await this.$client.post(
        "/api/company/updatePaymentPageActiveCompany",
        pp
      );
      return r.data.isSuccess;
    },
    async sendPaymentPageEmail(pp) {
      let r = await this.$client.post(
        "/api/company/sendPaymentPageEmailActiveCompany",
        pp
      );
      return r.data.isSuccess;
    },

    async bindUsers(isActive) {
      var r = await this.$client.get(
        "/api/user/activeCompanyUsers?isActive=" + isActive
      );
      if (r.data.isSuccess) {
        return r.data.value;
      }
    },
    async updateReceiptSettings(settings) {
      settings.companyId = this.companyId;

      var r = await this.$client.post(
        "/api/company/updateReceiptSettingsActiveCompany",
        settings
      );

      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "Receipt Settings Updated",
        });
      }
    },

    async submitCompany() {
      var self = this;

      let r = await this.$client.post(
        "/api/company/updateActiveCompany",
        this.company
      );

      if (r.data.isSuccess) {
        self.$emitter.emit("success", {
          title: "Updated",
          message: "Company has been updated.",
        });
      }
    },
  },
};
</script>

<style scoped>
.options {
  padding: 10px;
}

.card-body {
  padding: 0;
  margin: 0;
}

.card-body.contact-body {
  padding: 2em;
}
</style>
